






























































































































































































import Vue from 'vue';
import { BDropdown, BDropdownItem, BFormInput } from 'bootstrap-vue';
import { ZenLink, ProfileIcon } from 'zenComponents';

import { MainNavEntry, NavEntry } from './types';

export default Vue.extend({
  name: 'LHN',
  components: {
    BDropdown,
    BDropdownItem,
    BFormInput,
    ZenLink,
    ProfileIcon,
  },
  props: {
    newMenu: {
      type: Array,
      required: true,
    },
    navLinks: {
      type: Array,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
    routerPresent: {
      type: Boolean,
      default: false,
    },
    featureFlags: {
      type: Object,
      default: () => ({}),
    },
    shouldDisplay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      openSubmenu: <MainNavEntry | null>null,
      openUserMenu: <boolean>false,
      openHelpMenu: <boolean>false,
      LHNfilter: <string>'',
      embeddedComponent: <boolean>false,
    };
  },
  computed: {
    getPicture(): object {
      var image = '';
      if (this.info.user && this.info.user.profileImageUrl) {
        image = this.info.user.profileImageUrl.value;
      }
      return {
        avatar: image,
      };
    },
    helpMenuClass(): string {
      return `collapsable-menu ${this.openHelpMenu ? 'is-open' : ''}`;
    },
    userMenuClass(): string {
      return `collapsable-menu ${this.openUserMenu ? 'is-open' : ''}`;
    },
    links(): NavEntry[] {
      const term = this.LHNfilter.toLowerCase();

      if (!term.length) {
        return this.navLinks;
      }

      const results: NavEntry[] = [];

      this.navLinks.forEach((navLink: NavEntry) => {
        const item = JSON.parse(JSON.stringify(navLink));

        // Search submenu
        if (item.submenu) {
          const sublinks = item.submenu.filter(
            (subitem: Submenu) =>
              !subitem.section &&
              subitem.title
                .concat(subitem.link)
                .toLowerCase()
                .indexOf(term) > -1
          );

          if (sublinks.length) {
            item.expanded = true;
            item.submenu = sublinks;
            results.push(item);
          }
        } else if (
          item.title
            .concat(item.link)
            .toLowerCase()
            .indexOf(term) > -1
        ) {
          // If top level link is a match, return it as is
          results.push(item);
        }
      });

      return results;
    },
  },
  watch: {
    $route(route) {
      if (window.self !== window.top) {
        this.embeddedComponent = true;
        parent.postMessage(
          {
            action: 'urlUpdate',
            location: window.location.href,
          },
          '*'
        );
      } else {
        this.embeddedComponent = false;
      }
      if (route.name === 'sorListingPage') {
        return;
      }
      this.reset();
    },
  },
  methods: {
    reset() {
      this.openSubmenu = null;
      this.openUserMenu = false;
      this.openHelpMenu = false;
      this.LHNfilter = '';
    },
    navItemClass(entry: MainNavEntry): string {
      return entry === this.openSubmenu ? 'nav-link-is-open' : '';
    },
    navLinkClass(entry: MainNavEntry): string {
      return `nav-link top-level
              ${entry.title.toLowerCase().replace(/ /g, '-')}-link
              ${entry.submenu && !entry.expanded ? 'has-add-on' : ''}`;
    },
    navSubLinkClass(entry: NavEntry): string {
      return `nav-link sub-level
              ${entry.title.toLowerCase().replace(/ /g, '-')}-link`;
    },
    navIconClass(entry: MainNavEntry): string {
      return `icon fa fa-${entry.icon}`;
    },
    submenuClass(entry: MainNavEntry): string {
      return `submenu ${entry.expanded ? 'inline-menu' : ''}`;
    },
    toggleSubmenu(entry: MainNavEntry, ev: MouseEvent): void {
      if (!entry.submenu) {
        return;
      }

      ev.preventDefault();

      if (this.LHNfilter.length) {
        return;
      }

      this.openSubmenu = this.openSubmenu === entry ? null : entry;
    },
    menuTabindex(entry: MainNavEntry): number {
      return entry === this.openSubmenu ? 1 : -1;
    },
    tabNavigation(ev: KeyboardEvent): void {
      if (!this.openSubmenu) {
        return;
      } else if (ev.keyCode === 27 || (ev.keyCode === 9 && !document.activeElement.classList.contains('sub-level'))) {
        this.openSubmenu = null;
      }
    },
    toggleUserMenu(): void {
      this.openUserMenu = !this.openUserMenu;
    },
    toggleHelpMenu(): void {
      this.openHelpMenu = !this.openHelpMenu;
    },
    clearSearch(): void {
      this.LHNfilter = '';
    },
    isFlagEnabled(flagName: string) {
      if (this.routerPresent) {
        return this.$store.getters.featureFlagState(flagName);
      } else {
        return this.featureFlags[flagName] == true;
      }
    },
    getYear(): number {
      return new Date().getFullYear();
    },
    clickNewLink(item: NavEntry, event: Event) {
      const modalsAvailable = this.routerPresent || window.GGRC.zenModal;
      const creatingAudit = item.title.includes('Audit');
      const creatingDashboard = item.title.includes('Dashboard');

      // Open the New Dashboard page - temporary until synced with the dynamic object creation
      // TODO: ZEN-13369
      if (creatingDashboard) {
        event.preventDefault();
        if (this.routerPresent) {
          this.$router.push({
            path: '/dashboards/new',
          });
        } else {
          window.location.href = '/dashboards/new';
        }
      }

      if (!modalsAvailable || creatingAudit || creatingDashboard) return;

      event.preventDefault();
      this.showModal({
        type: 'NewObject',
        data: {
          url: item.link,
          type: item.title,
        },
      });
    },
    async showModal(modalConfig: object) {
      if (this.routerPresent) {
        try {
          await this.$store.dispatch('modals/show', modalConfig);
        } catch (e) {
          // User canceled modal
        }
      } else {
        window.GGRC.zenModal.show(modalConfig);
      }
    },
    intercomWidgetHandler(ev: MouseEvent) {
      if (window.Intercom) {
        ev.preventDefault();
        window.Intercom('show');
      }
    },
  },
});
